const queryKeys = {
  all: (distributionId: string) => ['parties', distributionId] as const,

  lists: (distributionId: string) =>
    [...queryKeys.all(distributionId), 'list'] as const,
  details: (distributionId: string) =>
    [...queryKeys.all(distributionId), 'detail'] as const,

  list: (distributionId: string, filter: unknown) =>
    [...queryKeys.lists(distributionId), filter] as const,

  byId: (id: string) => [...queryKeys.details(''), id] as const,

  checkup: (id: string) => [...queryKeys.byId(id), 'check-up'] as const,

  systemCampaigns: (id: string) =>
    [...queryKeys.byId(id), 'system-campaigns'] as const,
};

export default queryKeys;
